import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import {
  dateFormatter,
  getCountryByCode,
  getPersonTypeByInt,
  getSexByCode,
  getStringDate,
  getYearsBirthByArrivalDate,
  getYearsByDate,
  isEmptyObject,
  replaceDataImage,
  verifyGuestTypeByAB,
  verifyGuestTypeByAge,
} from '../../utils/index';
import CustomDateInput from '../../ui/Form/CustomDateInput';
import CustomInput from '../../ui/Form/CustomInput';
// import CustomSelect from '../../ui/Form/CustomSelect';
import { setGuestErrorMessage, setSelectedGuest } from './guestsSlice';
import { useSendImageToS3Mutation } from '../../services/ocrApi';
import { setDataOCR, setImageSide, setIntentsSearchSign, setNationality } from '../../app/store/ocrSlice';
import GenderList from '../../utils/GenderList';
import CountryExtendedList from '../../utils/CountryExtendedList';
import useGetDataOcr from '../../hooks/useGetDataOcr';
import CountrySelect from '../../ui/Form/CountrySelect.';
import { setErrorMessage, setIsLoading } from '../../app/store/majesticSlice';
import FormErrorsModal from '../../ui/Modals/FormErrorsModal';
import usePageNavigation from '../../hooks/usePageNavigation';
import GenderSelect from '../../ui/Form/GenderSelect';
import MessageErrorModal from '../../ui/Modals/MessageErrorModal';
import ErrorMessageOcrModal from '../../ui/Modals/ErrorMessageOcrModal';
import useHotel from '../../hooks/useHotel';
import useCreateGuestAndAws from '../../hooks/useCreateGuestAndAws';

function GuestDocumentationReviewPage() {
  const { language } = useSelector((state) => state.checking);
  const { selectedGuest, guestList, guestErrorMessage } = useSelector((state) => state.guests);
  const [selectGender, setSelectGender] = useState({});
  const [selectNationality, setSelectNationality] = useState({});
  const [showErrorsModal, setShowErrorsModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  // const [customError, setCustomError] = useState('');
  const [wasReset, setWasReset] = useState(false);
  const {
    dataOCR,
    documentType,
    imageFront,
    imageReverse,
    nationality: selectedNationality,
  } = useSelector((state) => state.ocr);
  const { booking } = useSelector((state) => state.booking);
  const [sendImageToS3, { isError, error }] = useSendImageToS3Mutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const {
    control,
    reset,
    trigger,
    register,
    setValue,
    watch,
    formState,
    handleSubmit,
  } = useForm();

  const { errors } = formState;

  const {
    handlerCreateGuest,
    handlerSendDocument,
    handlerSendMail,
    isErrorCreate,
    errorCreate,
    isErrorSendDocuments,
    errorSendDocuments,
    isErrorSendMail,
    errorSendMail,
    isSuccessCreate,
    isSuccessSendDocuments,
    isSuccessSendMail,
  } = useCreateGuestAndAws();
  const { navigateNextPage } = usePageNavigation();
  const { dataHotel } = useHotel();
  const { OCRData } = useGetDataOcr();

  // useEffect(() => {
  //   dispatch(setIntentsSearchSign(0));
  // }, [dispatch]);

  useEffect(() => {
    if (!isEmptyObject(selectedGuest) && !isEmptyObject(OCRData)) {
      const customTrigger = async () => {
        const dataCountry = getCountryByCode(OCRData.country);
        const sex = getSexByCode(OCRData.gender);
        // console.log({ ...OCRData, country: dataCountry, gender: sex })
        // setDefaultSex(sex)
        setSelectNationality(dataCountry);
        setSelectGender(sex);
        // // Establece los valores en los inputs
        await reset({ ...OCRData, country: dataCountry, gender: sex });
        setWasReset(true);
        // // Dispara la validacion global despues de establecer los valores
        // setTimeout(async () => {
        //   await trigger();
        // }, 10);
      };

      customTrigger();
    }

    return () => {
      // Limpia los esta y no envia los documentos
      // dispatch(setImageSide({ imageSide: 'clean' }));
    };
  }, [dispatch, t, trigger, reset, selectedGuest, booking, OCRData]);

  const onSubmit = async (data) => {
    // Stop run
    // if (selectedGuest.TipoPersona === '3' && (guestHolder.IDHuesped === '' || guestHolder.DatosComunicacion.EMail === '')) {
    //   dispatch(setErrorMessage({ message: t('TXT_WARNING_NO_COMPLETED_HOLDER', { holderName: guestHolder.Nombre_Pila }) }));
    //   return;
    // }
    // Stop run
    // Manda el mensaje de advertecia para la nacionalidad diferente
    // if (selectedNationality.iso3 !== data.country.iso3) {
    //   const message = t('TXT_ERROR_SELECTED_SAME_NATIONLITY', { dataCountry: data.country.iso3, selectedNationality: selectedNationality?.iso2 });
    //   dispatch(setErrorMessage({ message }));
    //   return;
    // }
    // console.log("verifyGuestTypeByAge", data.birthDate);
    const guestType = verifyGuestTypeByAge(
      getYearsBirthByArrivalDate(data.birthDate, booking.FechaEntrada)
    );

    if (!isEmptyObject(guestType)) {
      const initGuestType = getPersonTypeByInt(selectedGuest.TipoPersona);
      if (guestType.id !== initGuestType.id) {
        const message = t(
          'TXT_WARNING_NO_MACTH_GUEST_TYPE',
          {
            typeDocument: t(`TXT_${documentType}`).toLowerCase(),
            guestBirthday: `${parseInt(selectedGuest.Edad, 10)}-${initGuestType.tagkey}`,
            documentBirthday: `${parseInt(getYearsBirthByArrivalDate(data.birthDate, booking.FechaEntrada), 10)}-${guestType.tagkey}`,
          },
        );
        dispatch(setErrorMessage({ message, callAgency: true }));
        return;
      }
    }

    // const guestType = verifyGuestTypeByAB(booking.FechaEntrada, data.birthDate);

    // if (!isEmptyObject(guestType)) {
    //   if (guestType.id !== selectedGuest.TipoPersona) {
    //     const message = t('TXT_WARNING_DIFF_YEARS_BIRTHDAY', { guestBirthday: selectedGuest.Edad, documentBirthday: getYearsByDate(data.birthDate) });
    //     dispatch(setErrorMessage({ message, callAgency: true }));
    //     return;
    //   }
    // }

    let sameDocumentError = false;
    if (guestList.length > 0) {
      for (let i = 0; i < guestList.length; i += 1) {
        const guest = guestList[i];
        if (guest.IDDocumento === data.documentNumber) {
          sameDocumentError = true;
          break;
        }
      }
    }

    // Stop run
    if (sameDocumentError) {
      dispatch(setErrorMessage({ message: t('TXT_ERROR_EXIST_DOCUMENT_NUMBER') }));
      // setCustomError('No se puede usar el mismo documento en este huésped.');
      return;
    }

    const updateDataSelectedGuest = {
      ...selectedGuest,
      Nombre: data.lastNames,
      Nombre_Pila: data.name,
      FechaNacimiento: dateFormatter(data.birthDate, 'YYYYMMDD000000'),
      // PaisNacimiento: data.country,
      PaisNacimiento: data.country.iso2,
      FechaExpedicion: dateFormatter(data.expeditionDate, 'YYYYMMDD000000'),
      FechaCaducidad: dateFormatter(data.expirationDate, 'YYYYMMDD000000'),
      Edad: `0${getYearsBirthByArrivalDate(data.birthDate, booking.FechaEntrada)}`,
      IdiomaDocumentos: language,
      IDDocumento: data.documentNumber,
      Sexo: data.gender.Code2,
    };

    await dispatch(setSelectedGuest(updateDataSelectedGuest));

    console.log("data.birthDate", dateFormatter(data.birthDate, 'DD/MM/YYYY'));
    // const sexValue = data.gender?.Code ? data.gender?.Code : data.gender;
    const updateDataOcr = {
      ...dataOCR,
      front: {
        ...dataOCR.front,
        name: data.name,
        lastNames: data.lastNames,
        // firstName: data.firstName,
        birthDate: dateFormatter(data.birthDate, 'DD/MM/YY'),
        gender: data.gender.Code,
        expeditionDate: dateFormatter(data.expeditionDate, 'DD/MM/YY'),
        expirationDate: dateFormatter(data.expirationDate, 'DD/MM/YY'),
      },
      reverse: {
        // cic: 'INE',
        country: data.country.iso3,
        documentNumber: data.documentNumber,
        birthDate: dateFormatter(data.birthDate, 'DD/MM/YYYY'),
        gender: data.gender.Code,
        expirationDate: dateFormatter(data.expirationDate, 'DD/MM/YY'),
        nationality: data.country.nameES,
      },
    };

    dispatch(setNationality(data.country));
    await dispatch(setDataOCR(updateDataOcr));

    let documentTypeList = [];
    let documentList = [];
    const imgFront = replaceDataImage(imageFront);
    const imgBack = replaceDataImage(imageReverse);
    /* if (documentType === 'INE') {
      documentTypeList = ['front', 'back'];
      documentList = [
        { id: 'front', content: imgFront },
        { id: 'back', content: imgBack },
      ];
    } */
    documentTypeList = [
      'front',
      // , 'back'
    ];
    documentList = [
      { id: 'front', content: imgFront },
      // { id: 'back', content: imgBack },
    ];

    if (imgBack !== '') {
      documentTypeList.push('back');
      documentList.push({ id: 'back', content: imgBack });
    }

    // Si no busco la firma porque solicito dos imagenes
    // if (documentType === 'PASSPORT' && !OCRData.applySignPassport) {
    //   documentTypeList = ['front'];
    //   documentList = [{ id: 'front', content: imgFront }];

    //   if (imgBack !== '') {
    //     documentTypeList.push('back');
    //     documentList.push({ id: 'back', content: imgBack });
    //   }
    // }

    const params = {
      documentTypeList,
      documentList,
      hotel: booking.HotelFactura,
      dateArrive: getStringDate(booking.FechaEntrada),
      numberReservation: booking?.NumReserva,
      numberDocument: data.documentNumber,
      nameGuest: data.name,
    };

    await sendImageToS3(params).unwrap();

    if (['2', '3'].includes(selectedGuest.TipoPersona)) {
      await handlerCreateGuest(updateDataSelectedGuest);
      await handlerSendDocument(OCRData, dataHotel, updateDataSelectedGuest);
      await handlerSendMail(OCRData, dataHotel, updateDataSelectedGuest);
      navigateNextPage('Booking');
      // Limpia images
      dispatch(setImageSide({ imageSide: 'clean' }));
      return;
    }

    // Limpia images
    dispatch(setImageSide({ imageSide: 'clean' }));
    dispatch(setIsLoading(false));
    // navigate('/Residence');
    navigateNextPage('Residence');
  };

  const handleChangeCountry = (selectedOption) => {
    // console.log('Seleccionado:', selectedOption);
    setSelectNationality(selectedOption);
  };

  const handleChangeGender = (selectedOption) => {
    setSelectGender(selectedOption);
  };

  const onError = (errorList) => {
    const messages = Object.values(errorList).map((errorItem) => errorItem.message || 'Campo inválido');
    setErrorMessages(messages);
    setShowErrorsModal(true);
  };

  useEffect(() => {
    const customTrigger = async () => {
      const result = await trigger();

      if (!result) {
        const message = t('TXT_NO_DETECT_FIELD_DOCUMENT', { documentType: t(`TXT_${documentType}`) })
        dispatch(setGuestErrorMessage({ message, showErrorModal: true }));
        onError(errors);
      }
    };

    if (wasReset) {
      setTimeout(async () => {
        customTrigger();
      }, 50);
    }
  }, [dispatch, t, trigger, wasReset, errors, documentType]);

  const handleCloseModal = () => {
    // setCustomError('');
    dispatch(setGuestErrorMessage({ message: '' }));
    setShowErrorsModal(false);
  };

  return (
    <div className="guest__document-review d-flex flex-column h-100">
      <div className="text-center">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="mt-3 mb-1 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">
          {t('TXT_NUMBER_GUEST', { customNumber: selectedGuest?.customNumber })}
        </p>
        <p className="mb-3 app-fs-12 app-txt-granite-80-dark">
          {t(`TXT_GUEST_${selectedGuest.TipoPersona}`)}
          {' '}
          |
          {' '}
          {t(`TXT_BETWEEN_YEARS_PERSON_TYPE_0${selectedGuest.TipoPersona}`)}
        </p>

        <p className="mb-3 app-txt-granite-80-dark">{t('TXT_REVIEW_INFORMATION')}</p>
      </div>

      <FormProvider
        control={control}
        handleSubmit={handleSubmit}
        setValue={setValue}
        watch={watch}
        formState={formState}
        register={register}
      >
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="dr__form d-flex flex-column h-100">
          <CustomInput
            control={control}
            name="name"
            formLabel={t('TXT_NAME')}
            rules={
              {
                required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_NAME') })}`,
                minLength: {
                  value: 3,
                  message: `${t('TXT_ERROR_MIN_INPUT', { inputName: t('TXT_NAME'), minLength: 5 })}`,
                },
                maxLength: {
                  value: 60,
                  message: `${t('TXT_ERROR_MAX_INPUT', { inputName: t('TXT_NAME'), maxLength: 60 })}`,
                },
                validate: (value) => value.trim() !== '' || 'No puede estar vacío',
              }
            }
            clearCaracter
            regexClear="[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ´\s]"
            defaultValue={OCRData.name}
            classNames={{
              card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
              cardBody: 'px-2 py-1',
              label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
              input: 'app-txt-granite-80-dark app-fs-14',
            }}
          />
          <CustomInput
            control={control}
            // name="firstName"
            name="lastNames"
            formLabel={t('TXT_LAST_NAMES')}
            rules={
              {
                required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_LAST_NAMES') })}`,
                minLength: {
                  value: 3,
                  message: `${t('TXT_ERROR_MIN_INPUT', { inputName: t('TXT_LAST_NAMES'), minLength: 5 })}`,
                },
                maxLength: {
                  value: 60,
                  message: `${t('TXT_ERROR_MAX_INPUT', { inputName: t('TXT_LAST_NAMES'), maxLength: 60 })}`,
                },
                validate: (value) => value.trim() !== '' || 'No puede estar vacío',
              }
            }
            clearCaracter
            regexClear="[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ´\s]"
            // defaultValue={ineFront.firstName}
            defaultValue={OCRData.lastNames}
            classNames={{
              card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
              cardBody: 'px-2 py-1',
              label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
              input: 'app-txt-granite-80-dark app-fs-14',
            }}
          />

          <Row className="mx-">
            <Col xs={6} sm={6} lg={6} className="pe-1">
              <CountrySelect
                control={control}
                name="country"
                formLabel={t('TXT_LABEL_NATIONALITY')}
                placeHolder={t('TXT_SELECT_VALUE')}
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_LABEL_NATIONALITY') })}` }}
                defaultValue={selectNationality}
                options={CountryExtendedList}
                controlHeight={20}
                classNamePrefix="form-review"
                handleOnChange={handleChangeCountry}
                classNames={{
                  card: 'border-solid-1 transition-border-color border-gray mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                }}
              />
              <CustomInput
                control={control}
                name="documentNumber"
                formLabel={t('TXT_NUMBER_DOCUMENT')}
                rules={
                  {
                    required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_NUMBER_DOCUMENT') })}`,
                    minLength: {
                      value: 3,
                      message: `${t('TXT_ERROR_MIN_INPUT', { inputName: t('TXT_NUMBER_DOCUMENT'), minLength: 5 })}`,
                    },
                    maxLength: {
                      value: 60,
                      message: `${t('TXT_ERROR_MAX_INPUT', { inputName: t('TXT_NUMBER_DOCUMENT'), maxLength: 60 })}`,
                    },
                    validate: (value) => value.trim() !== '' || 'No puede estar vacío',
                  }
                }
                clearCaracter
                regexClear="[^a-zA-Z0-9áéíóúüñÁÉÍÓÚÜÑ-]"
                defaultValue={OCRData.documentNumber}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark app-fs-14',
                }}
              />
              <CustomDateInput
                control={control}
                name="expeditionDate"
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_EXPEDITION_DATE') })}` }}
                defaultValue={OCRData.expeditionDate}
                // icon={faCalendarDays}
                formLabel={t('TXT_EXPEDITION_DATE')}
                labelId="expeditionDate"
                blockFutureDate={booking.FechaEntrada}
                showMoth
                showYear
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
              <GenderSelect
                control={control}
                name="gender"
                formLabel={t('TXT_SEX')}
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_SEX') })}` }}
                defaultValue={selectGender}
                options={GenderList}
                classNamePrefix="form-review"
                handleOnChange={handleChangeGender}
                // controlHeight={24}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark',
                }}
              />
            </Col>
            <Col xs={6} sm={6} lg={6} className="ps-1">
              <CustomDateInput
                control={control}
                name="birthDate"
                rules={{ required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_BIRTH_DATE') })}` }}
                defaultValue={OCRData.birthDate}
                // icon={faCalendarDays}
                formLabel={t('TXT_BIRTH_DATE')}
                labelId="birthDate"
                blockFutureDate
                showMoth
                showYear
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
              <CustomInput
                disabled
                control={control}
                name="documentType"
                formLabel={t('TXT_DOCUMENT_TYPE')}
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_DOCUMENT_TYPE') })}` }}
                defaultValue={documentType}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
              <CustomDateInput
                control={control}
                name="expirationDate"
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_EXPIRATION_DATE') })}` }}
                defaultValue={OCRData.expirationDate}
                // icon={faCalendarDays}
                formLabel={t('TXT_EXPIRATION_DATE')}
                labelId="expirationDate"
                blockDate={booking.FechaEntrada}
                // blockFutureDate
                showMoth
                showYear
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            </Col>
          </Row>

          <div className="d-flex flex-grow-1 align-items-end pb-2 mt-3">
            <Button
              variant=""
              type="submit"
              // disabled={!isValid}
              className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
            >
              {t('TXT_BOTON_CONTINUE')}
            </Button>
          </div>
        </Form>
      </FormProvider>

      {isErrorCreate && <MessageErrorModal message={errorCreate.message} />}
      {isError && <ErrorMessageOcrModal />}
      {isErrorSendDocuments && <ErrorMessageOcrModal />}
      {isErrorSendMail && <ErrorMessageOcrModal />}
      <FormErrorsModal
        message={guestErrorMessage}
        showModal={showErrorsModal}
        errorMessageList={errorMessages}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
}

export default GuestDocumentationReviewPage;
